import { inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { GtmPushService } from './gtm-push.service';
import { BrowserApiSupportService } from '@lentau/ui-kit/core/services/browser-api-support/browser-api-support.service';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsInterceptorService {
  private gtmService: GoogleTagManagerService = inject(GoogleTagManagerService);
  private gtmPushService: GtmPushService = inject(GtmPushService);
  private browserApi: BrowserApiSupportService = inject(BrowserApiSupportService);

  private isBrowser: boolean = this.browserApi.isBrowser();
  private initialVariablesImplemented$: BehaviorSubject<object> = new BehaviorSubject(null);

  public handleVariablesUpdates(gtmVariables: object): void {
    if (!this.initialVariablesImplemented$.value) {
      this.setInitialVariables(gtmVariables);
    } else {
      this.checkVariablesChanges(gtmVariables);
    }
  }

  private checkVariablesChanges(gtmVariables: object): void {
    const newData = { ...gtmVariables };
    const oldData = { ...this.initialVariablesImplemented$.value };

    if (Object.entries(newData).toString() !== Object.entries(oldData).toString()) {
      Object.keys(newData).forEach((key) => {
        if (newData[key] !== oldData[key]) {
          this.gtmPushService.pushToDataLayer({ [key]: newData[key] });
          this.initialVariablesImplemented$.next({ ...this.initialVariablesImplemented$.value, [key]: newData[key] });
        }
      });
    }
  }

  private setInitialVariables(initialVariables: object): void {
    if (this.isBrowser) {
      this.gtmService.getDataLayer().unshift({ ...initialVariables, siteType: 'new' });
      this.initialVariablesImplemented$.next({ ...initialVariables });
    }
  }
}
